import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import VisitorAnalyticsPage from "@/pages/admin/VisitorAnalyticsPage";

export const Route = createFileRoute("/_admin/admin/visitor-analytics")({
  head: () => pageHead("Admin · Visitor Analytics", "AKIVA admin · visitor analytics portal.", "/admin/visitor-analytics", true),
  component: VisitorAnalyticsPage,
});
